export default "__VITE_PUBLIC_ASSET__a9e4057d__"